import { c as _c } from "react/compiler-runtime";
import { useAuth0, User } from "@auth0/auth0-react";
import { useRef, useState } from "react";
import { ChevronDown } from "react-feather";
import { useClickOutsideAlerter } from "../../../../hooks/useClickOutsideAlerter";
import { TaxUnit } from "../../../../models";
import { useTaxUnits } from "../../../../_queries";
import styles from "./TaxUnitSelector.module.scss";
export const TaxUnitSelector: React.FC<{
  selected: TaxUnit | null;
  exclude?: TaxUnit[];
  onChange: (selectedTaxUnit: TaxUnit) => void;
  onAddNew: () => void;
  placeholder?: string;
  addNewLabel?: string;
  loadingLabel?: string;
  errorLabel?: string;
}> = t0 => {
  const $ = _c(30);
  const {
    selected,
    exclude: t1,
    onChange,
    onAddNew,
    placeholder: t2,
    addNewLabel: t3,
    loadingLabel: t4,
    errorLabel: t5
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const exclude = t6;
  const placeholder = t2 === undefined ? "Velg skatteenhet" : t2;
  const addNewLabel = t3 === undefined ? "Legg til ny enhet" : t3;
  const loadingLabel = t4 === undefined ? "Laster..." : t4;
  const errorLabel = t5 === undefined ? "En feil oppstod" : t5;
  const {
    getAccessTokenSilently,
    user
  } = useAuth0();
  const [menuOpen, setMenuOpen] = useState(false);
  const actionRef = useRef(null);
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setMenuOpen(false);
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  useClickOutsideAlerter(actionRef, t7);
  const {
    data,
    loading,
    error
  } = useTaxUnits(user as User, getAccessTokenSilently);
  let t8;
  if ($[3] !== menuOpen) {
    t8 = () => setMenuOpen(!menuOpen);
    $[3] = menuOpen;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const t9 = selected ? selected.name : placeholder;
  let t10;
  if ($[5] !== t9) {
    t10 = <div className={styles.left}><div className={styles.name}>{t9}</div></div>;
    $[5] = t9;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  const t11 = selected ? selected.ssn : "";
  let t12;
  if ($[7] !== t11) {
    t12 = <div className={styles.ssn}>{t11}</div>;
    $[7] = t11;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  let t13;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className={styles.arrow}><ChevronDown size="1.2rem" /></div>;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] !== t12) {
    t14 = <div className={styles.right}>{t12}{t13}</div>;
    $[10] = t12;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  if ($[12] !== t10 || $[13] !== t14 || $[14] !== t8) {
    t15 = <button onClick={t8} className={styles.button}>{t10}{t14}</button>;
    $[12] = t10;
    $[13] = t14;
    $[14] = t8;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== addNewLabel || $[17] !== data || $[18] !== error || $[19] !== errorLabel || $[20] !== exclude || $[21] !== loading || $[22] !== loadingLabel || $[23] !== menuOpen || $[24] !== onAddNew || $[25] !== onChange) {
    t16 = menuOpen && <div className={styles.menu}>{loading && <div>{loadingLabel}</div>}{error && <div>{errorLabel}</div>}{data && data.filter(_temp).filter(taxUnit_0 => !exclude.map(_temp2).includes(taxUnit_0.id)).map(taxUnit_1 => <button onClick={() => {
        setMenuOpen(false);
        onChange(taxUnit_1);
      }} className={styles.menuItem} key={taxUnit_1.id}><div className={styles.inner}><div className={styles.name}>{taxUnit_1.name}</div><div className={styles.ssn}>{taxUnit_1.ssn}</div></div></button>)}<button onClick={() => {
        setMenuOpen(false);
        onAddNew();
      }} className={styles.menuItem}><div className={styles.inner}><div className={styles.name}>{addNewLabel}</div></div></button></div>;
    $[16] = addNewLabel;
    $[17] = data;
    $[18] = error;
    $[19] = errorLabel;
    $[20] = exclude;
    $[21] = loading;
    $[22] = loadingLabel;
    $[23] = menuOpen;
    $[24] = onAddNew;
    $[25] = onChange;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t15 || $[28] !== t16) {
    t17 = <div className={styles.container} ref={actionRef}>{t15}{t16}</div>;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
};
function _temp(taxUnit) {
  return taxUnit.archived === null;
}
function _temp2(u) {
  return u.id;
}